import { HiOutlineDocumentText } from "react-icons/hi2";
import { LuDownload } from "react-icons/lu";

export default function FileDownloadCard({ fileName, downloadUrl }) {
  return (
    <div className="max-w-xs cursor-pointer bg-gray-100 dark:bg-gray-800 px-3 py-[2px] rounded-sm shadow flex items-center space-x-4">
      <HiOutlineDocumentText size={25} className="bg-red-500 text-white p-1 rounded" />  
      <div className="flex-grow">
        <p className="trucate w-[120px] text-[13px] text-gray-900 dark:text-white truncate">{fileName}</p>
      </div>
      <a
        href={downloadUrl}
        download
        target="_blank"
        className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition"
        title="Download"
      >
        <LuDownload className="w-5 h-5 text-gray-700 dark:text-gray-200" />
      </a>
    </div>
  )
}